:host {
  display: block;
  overflow: hidden;
}

.dc-ui-image-wrapper {
  display: block;
  width: 100%;
  height: auto;

  &--hover-scale {
    transition: transform 160ms ease-in;
    // Scale based on CSS custom property set by parent component
    // Parent component should set --nested-element-hover-scale: 1 on hover
    transform: scale(calc(1 + (var(--nested-element-hover-scale, 0) * 0.25)));
  }
}
